enum BookWithMeEntryPoint {
    Organizer,
    Attendee,
}

export default BookWithMeEntryPoint;
